import { Resources } from 'constants/resources';

import { usePermissions } from 'hooks/usePermissions';
import { useRecordModal } from 'hooks/useRecordModal';
import { useShowController } from 'react-admin';
import { DeleteButton, EditLinkButton } from 'shared/mui/Buttons';
import {
  ContextMenu,
  ContextMenuEntityUserActionsButton,
  ContextMenuUserActionsButton,
} from 'shared/mui/ContextMenu';
import { ShowPage } from 'shared/react-admin/Pages/ShowPage/ShowPage';
import { Permission } from 'types/embedded/permission';
import { User } from 'types/embedded/user';

import { UsersShowChipFields } from './UsersShowChipFields';
import { UsersShowTable } from './UsersShowTable';
import { UsersDeleteModal } from '../components/UsersDeleteModal';

export const UsersShow: React.FC = () => {
  const { hasResourcePermissions } = usePermissions();
  const { record } = useShowController<User>();
  const { handleCloseRecordModal, openRecordModal, handleOpenRecordModal } = useRecordModal<User>();

  return (
    <ShowPage
      actions={
        <ContextMenu>
          <ContextMenuEntityUserActionsButton entityName="user" />
          <ContextMenuUserActionsButton />
        </ContextMenu>
      }
      listName="Пользователи"
      rightActionsSlot={[
        hasResourcePermissions(Resources.Users, [Permission.Full, Permission.Delete]) && (
          <DeleteButton
            key="delete-button"
            onClick={() => handleOpenRecordModal(record)}
            variant="outlined"
          />
        ),
        hasResourcePermissions(Resources.Users, [Permission.Full, Permission.Update]) && (
          <EditLinkButton key="edit-button" label="Редактировать" variant="contained" />
        ),
      ]}
      title="Просмотр пользователя"
    >
      <UsersShowChipFields />
      <UsersShowTable />
      <UsersDeleteModal
        handleCloseRecordModal={handleCloseRecordModal}
        openRecordModal={openRecordModal}
        record={record}
      />
    </ShowPage>
  );
};
